var map = {
	"./en_us.json": [
		"rxFH"
	],
	"./tc_cn.json": [
		"FJx0"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "pSzQ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/language/package lazy ^\.\/.*\.json$
// module id = pSzQ
// module chunks = 57